export const zhHant = {
  common: {
    loading: '載入中...',
    email: '郵箱地址',
    emailRequired: '請輸入郵箱地址！',
    emailValid: '請輸入有效的郵箱地址！',
    password: '密碼',
    passwordRequired: '請輸入密碼！',
    passwordMin: '密碼長度不能小於6位！',
    confirmPassword: '確認密碼',
    confirmPasswordRequired: '請確認密碼！',
    confirmPasswordNotMatch: '兩次輸入的密碼不一致！',
    phone: '手機號',
    phoneRequired: '請輸入手機號！',
    phoneValid: '請輸入有效的手機號！',
    code: '驗證碼',
    codeRequired: '請輸入驗證碼！',
    back: '返回',
    and: '和',
    agreementUser: '《用戶協議》',
    agreementPrivacy: '《隱私協議》',
    submit: '提交',
    contact: '聯絡方式',
    feedback: '反饋',
    success: '操作成功',
    fail: '操作失敗',
    nickname: '暱稱',
    avatar: '頭像',
    language: '選擇介面語言',
    logout: '退出登入',
    privacy: '隱私協議',
    manual: '使用說明',
    userAgreement: '用戶協議',
    ok: '確定',
    move: '移動',
    cancel: '取消',
    delete: '刪除',
    deleteForever: '永久刪除',
    edit: '編輯',
    warning: '警告',
    info: '提示',
    yes: '是',
    no: '否',
    copy: '複製',
    export: '匯出',
    save: '儲存',
    close: '關閉',
    empty: '暫無資料',
    input: '請輸入',
    name: '名稱',
    newName: '新名稱',
    unchanged: '未發生變化',
    updateSuccess: '更新成功',
    updateFail: '更新失敗，請稍後重試',
    deleteSuccess: '刪除成功',
    deleteFail: '刪除失敗，請稍後重試',
    confirmDelete: '確認刪除',
    confirm: '確認',
    know: '知道了',
    file: '檔案',
    sessionExpired: '登入已過期，請重新登入',
    noPermission: '沒有權限存取該資源',
    resourceNotFound: '請求的資源不存在',
    methodNotAllowed: '請求方法不允許',
    serverError: '伺服器錯誤，請稍後重試',
    networkError: '網路錯誤，請檢查您的網路連線',
    requestConfigError: '請求配置錯誤',
    requestFailed: '請求失敗',
    fileName: '檔案名',
    fileType: '檔案類型',
    fileList: '檔案記錄',
    operation: '操作',
    rename: '重新命名',
    sync: '同步',
    detail: '詳情',
    download: '下載',
    retry: '重試',
    start: '開始',
    stop: '停止',
    continue: '繼續',
    finish: '完成',
    tip: '提示',
    more: '更多',
    search: '搜尋',
    moveFolder: '移至資料夾',
    moveRecycle: '移至回收站',
    recover: '恢復',
    myFolder: '我的資料夾',
    createNewFolder: '+ 新建資料夾',
  },
  aside: {
    allFile: '全部檔案',
    allTypes: '全部類型',
    allFolder: '資料夾',
    noFolder: '暫無資料夾',
    setting: '偏好設定',
    helpFeed: '幫助與反饋',
    code: '二維碼',
    scanCode: '掃碼下載APP',
  },
  login: {
    title: '帳號登入',
    emailLogin: '郵箱登入',
    phoneLogin: '手機號登入',
    loginBtn: '登入',
    forgot: '忘記密碼',
    noAccount: '還沒有帳號？',
    register: '立即註冊',
    agreementPrefix: '繼續使用表示您已閱讀並接受',
    loginSuccess: '登入成功！',
    loginFail: '登入失敗，請檢查用戶名和密碼！',
    getCode: '獲取驗證碼',
    codeSent: '驗證碼已發送',
    codeFail: '驗證碼發送失敗，請稍後重試！',
    resend: '重新發送',
    resendIn: '秒後重新發送',
  },
  profile: {
    avatar: '頭像',
    nickname: '暱稱',
    personalInfo: '個人資訊',
    language: '選擇顯示語言',
    logout: '退出登入',
    privacy: '隱私協議',
    manual: '使用說明',
    userAgreement: '用戶協議',
  },
  register: {
    title: '註冊帳戶',
    agree: '我已閱讀並同意',
    submit: '確認',
    agreeTip: '請同意用戶協議和隱私政策！',
    success: '註冊成功！請登入',
    fail: '註冊失敗，請稍後重試！',
  },
  resetPassword: {
    title: '修改密碼',
    code: '請輸入收到的驗證碼',
    codeRequired: '請輸入收到的驗證碼！',
    getCode: '獲取驗證碼',
    codeSent: '驗證碼已發送，請查收郵箱',
    codeFail: '驗證碼發送失敗，請稍後重試！',
    newPassword: '請輸入新密碼！',
    submit: '確認修改',
    emailTip: '請先輸入郵箱！',
    success: '密碼修改成功，請重新登入！',
    fail: '密碼修改失敗，請稍後重試！',
  },
  feedback: {
    title: '反饋',
    contentLabel: '您遇到的問題或建議',
    contentPlaceholder: '請詳細描述您遇到的問題或建議...',
    contentRequired: '請輸入詳細內容',
    typeLabel: '問題類型',
    typeLabelHolder: '請選擇反饋類型',
    typeRequired: '請輸入反饋標題',
    typeBug: '功能異常',
    typeFeature: '功能建議',
    typeUI: '介面優化',
    typePerformance: '效能問題',
    typeOther: '其他',
    contactLabel: '聯絡方式',
    contactRequired: '請輸入聯絡方式',
    contactPlaceholder: '請輸入您的聯絡方式',
    submit: '提交反饋',
    success: '感謝您的反饋！',
    fail: '提交失敗，請稍後重試',
  },
  file: {
    welcome: '歡迎使用悦会WEB!',
    listTitle: '檔案記錄',
    recycle: '回收站',
    deleteTitle: '刪除檔案',
    deleteContent: '此檔案將被永久刪除且無法恢復，是否確認刪除？',
    deleteOk: '刪除',
    deleteCancel: '取消',
    deleteSuccess: '檔案刪除成功',
    deleteFail: '刪除檔案失敗，請稍後重試',
    transcription: '轉寫內容',
    welcomeTranscription: '歡迎體驗人工智慧轉寫功能!',
    generate: '生成',
    transcribing: '轉寫正在生成中...',
    transcribingTip: '這將需要幾分鐘，完成後將自動顯示結果，您可以離開此頁面或在此等待',
    transcribeFail: '轉寫生成失敗！',
    transcribeFailTip: '非常遺憾，轉寫操作未能成功完成，建議您再次進行生成嘗試',
    regenerate: '重新生成',
    regenerateTrans: '是否確認重新嘗試生成當前音訊的轉寫內容?',
    regenerateSummary: '是否確認重新嘗試生成當前音訊的總結內容?',
    summaryGenerating: '總結正在生成中...',
    summaryGeneratingTip: '轉寫結果已生成，總結生成還需幾分鐘，您可以繼續等待或者查看轉寫內容',
    viewTranscription: '查看轉寫結果',
    summaryFail: '總結生成失敗',
    summaryFailTip: '很抱歉，總結生成失敗，請稍後再試',
    selectTemplate: '選擇模板',
    selectTemplateLanguage: '精轉語言',
    meetingSummary: '會議紀要',
    topic: '主題',
    todo: '待辦事項',
    interview: '採訪/面試',
    qa: '問答',
    opinion: '觀點',
    speech: '演講',
    summary: '摘要',
    question: '問題',
    startTranscribing: '正在開始轉寫...',
    transcribeStarted: '轉寫已開始，請稍後查看結果',
    transcribeFailRetry: '轉寫失敗，請稍後重試',
    transcribe: '轉寫',
    retranscribe: '重新轉寫',
    resummarize: '重新總結',
    rename: '重新命名',
    AddFolder: '創建資料夾',
    addFolderPlaceholder: '請輸入資料夾名稱',
    renamePlaceholder: '請輸入新的檔案名',
    renameOk: '確認',
    renameCancel: '取消',
    renameSuccess: '檔案名更新成功',
    createFolderFail: '資料夾創建失敗',
    createFolderSuccess: '資料夾創建成功',
    renameFail: '檔案名更新失敗，請稍後重試',
    renameUnchanged: '檔案名無變化',
    renameRequired: '請輸入新的檔案名',
    delete: '刪除',
    copyTranscription: '複製轉寫內容',
    copySummary: '複製總結',
    exportTranscription: '匯出轉寫內容',
    exportSummary: '匯出總結',
    exportMindmap: '匯出思維導圖',
    exportMp3: '匯出音訊',
    copy: '複製',
    export: '匯出',
    empty: '內容為空',
    exportSuccess: '匯出成功',
    exportFail: '匯出失敗',
    syncTip: '了解如何同步資料',
    syncTipDesc: '如需在此查看您的資料，請打開最新版的悦会 APP，並啟用悦会 PRIVATE CLOUD。這將安全地備份您的資料，並同步至雲端，方便您透過各種裝置存取。',
    copySuccess: '內容已複製到剪貼簿',
    dateTime: '日期時間',
    location: '地點',
    attendees: '與會人員',
    meetingRecord: '會議記錄',
    nextStep: '下一步',
    interviewer: '採訪人',
    conclusion: '結論',
    speaker: '主講人',
    abstract: '摘要',
    keyPoints: '要點',
    questions: '問題',
    assignments: '作業',
    showList: '顯示列表',
    hideList: '隱藏列表',
    hideTranscript: '隱藏轉寫',
    showTranscript: '顯示轉寫',
    summaryz: '總結',
    mind: '思維導圖',
    zd: '自動適配',
    zdTag1: '自動適配',
    zx: '諮詢',
    zxTag1: '成果',
    zxTag2: '決策',
    hb: '匯報',
    hbTag1: '進展',
    hbTag2: '問題',
    tl: '討論',
    tlTag1: '結論',
    tlTag2: '要點',
    bj: '課堂筆記',
    bjTag1: '知識點',
    bjTag2: '講解',
    px: '培訓',
    pxTag1: '關鍵點',
    pxTag2: '注意',
    xq: '需求評估',
    xqTag1: '痛點',
    xqTag2: '期待',
    moveSuccess: '移動成功',
    moveFail: '移動失敗',
    moveSelectFile: '請選擇要移動資料夾',
    notCate: '未分類',
    recoverSuccess: '移動成功',
    recoverFail: '移動失敗',
    editFolder: '編輯資料夾',
    folderNameUnchanged: '資料夾名稱未變化',
    folderExists: '資料夾已存在',
    invalidCharacters: '名稱包含非法字元,請修改後重試',
    updateFolderSuccess: '資料夾更新成功',
    updateFolderFail: '資料夾更新失敗',
    deleteFolderTips: '此資料夾將被永久刪除，資料夾中的檔案會被移入回收站，請確認是否刪除？',
    insufficientBalance: '餘額不足',
    insufficientBalanceMessage: '轉寫時長不足，無法完成轉錄。',
    zoomIn: '放大',
    zoomOut: '縮小',
    fitView: '恢復視圖',
    editTitle: '點擊編輯標題',
    editContent: '點擊編輯內容',
    titlePlaceholder: '輸入標題...',
    contentPlaceholder: '輸入內容，或使用 / 命令插入模組',
    saving: '儲存中...',
    saveSuccess: '儲存成功',
    saveFailed: '儲存失敗',
    titleSaveSuccess: '標題已更新',
    contentSaveSuccess: '內容已更新',
    sessionExpired: '會話已過期，請重新登入',
  },
  blockNoteEditor: {
    heading2: '二級標題',
    heading3: '三級標題',
    heading4: '四級標題',
    quote: '引用',
    bulletList: '無序列表',
    numberedList: '有序列表',
  },
  vip: {
    lock: '解鎖免費會員',
    lockDesc: '綁定裝置啟動會員權益',
    lockNowBtnText: '立即解鎖',
    starVipName: '初級會員',
    proVipName: '中級會員',
    unlimitedVipName: '高級會員',
    transTimeName: '轉寫時長包',
    timeReset: '重置',
    timeEnd: '到期',
    usedUp: '已用完',
    minutesLeft: '剩餘 {count} 分鐘',
    lockTitle: '解鎖免費會員',
    lockSubTitle: '請打開悦会 APP 並綁定裝置，即可啟動會員權益',
    lockRights1: '每月免費轉寫時長',
    lockRights2: '多種場景模板總結',
    lockRights3: '區分不同說話人',
    lockRights4: '智慧降噪，提升音訊回放效果',
    lockRights5: '支援多種匯出格式',
  }
};
